import React, {useEffect, useState} from "react";

import {
  Button, Input, InputGroup, InputRightElement, useStyleConfig,
} from "@chakra-ui/react";

/**
 * Password Input
 * Props:
 *  onChange
 *  isInvalid
 */
export default function PasswordComponent(props) {

  const styledButton = useStyleConfig('StyledButton', {variant: "passwordShow"});
  const {onChange, isInvalid} = props;
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (onChange) {
      onChange(password);
    }
  }, [password]);

  return (<InputGroup>
      <Input
        type={showPassword ? 'text' : 'password'}
        value={password}
        isInvalid={isInvalid}
        onChange={(e) => setPassword(e.target.value)}
      />
      <InputRightElement width='4.5rem'>
        <Button
          __css={styledButton}
          h='1.75rem'
          size='sm'
          variant="passwordShow"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? 'Hide' : 'Show'}
        </Button>
      </InputRightElement>
    </InputGroup>);
}
